
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","viewBox":"0 0 11.906 11.906","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon",attrs:{"d":"M5.958.485a5.455 5.455 0 013.038.922A5.457 5.457 0 0111.01 3.86a5.455 5.455 0 01.311 3.159 5.455 5.455 0 01-1.496 2.8 5.455 5.455 0 01-2.8 1.496 5.455 5.455 0 01-3.16-.311A5.453 5.453 0 011.413 8.99 5.456 5.456 0 01.49 5.953a5.455 5.455 0 01.922-3.038A5.455 5.455 0 013.866.901 5.455 5.455 0 015.958.485z"}}),_c('path',{staticClass:"icon",attrs:{"d":"M4.978 3.762l3.286 2.19-3.286 2.191z"}})])
          )
        }
      }
    